export default function srt2vtt(srt) {
    return 'WEBVTT \r\n\r\n'.concat(
        srt
            .replace(/\{\\([ibu])\}/g, '</$1>') // Replace {\i}, {\b}, {\u} with </i>, </b>, </u>
            .replace(/\{\\([ibu])1\}/g, '<$1>') // Replace {\i1}, {\b1}, {\u1} with <i>, <b>, <u>
            .replace(/\{([ibu])\}/g, '<$1>') // Replace {i}, {b}, {u} with <i>, <b>, <u>
            .replace(/\{\/([ibu])\}/g, '</$1>') // Replace {/i}, {/b}, {/u} with </i>, </b>, </u>
            .replace(/(\d\d:\d\d:\d\d)(?:,(\d\d\d))?/g, (match, p1, p2) => `${p1}.${p2 || '000'}`) // Replace time format from hh:mm:ss,ms to hh:mm:ss.ms
            .replace(/^\d+\r?\n/gm, '') // Remove subtitle index numbers
            .replace(/{[\s\S]*?}/g, '') // Remove any other curly brace content
            .concat('\r\n\r\n'),
    );
}
